import { connect } from "react-redux";

import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import {
    OptionalBlockVisibilityFieldName,
    OptionalElementsExistenceFieldName,
    TruthyTechnicalFieldValue,
} from "../../../../../Common/PathConstants";
import { OptionalBlockId } from "../../../../../Generator/src/generators/DataDeclarationGenerator/DataDeclaration";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";

import { OptionalBlock, OptionalBlockProps } from "./OptionalBlock";

interface OptionalBlockContainerProps {
    id: OptionalBlockId;
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
}

type OptionalBlockPropsFromState = Pick<
    OptionalBlockProps,
    "isBlockInitiallyVisible" | "isReadOnly" | "legacyBindingPath"
>;

const mapStateToProps = (state: FullFormState, ownProps: OptionalBlockContainerProps): OptionalBlockPropsFromState => {
    const { bindingPath, viewModelSelect } = ownProps;

    const visibilityFieldPath = bindingPath.joinWith(OptionalBlockVisibilityFieldName);
    const visibilityFieldValue = viewModelSelect.pathViewModelOrUndefined(state, visibilityFieldPath)?.value;
    const isBlockVisible = Boolean(visibilityFieldValue);

    return {
        isBlockInitiallyVisible: isBlockVisible,
        isReadOnly: Boolean(state.settings.isReadOnly),
        legacyBindingPath: bindingPath.toLegacyPath(),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: OptionalBlockContainerProps) => {
    const { id, bindingPath } = ownProps;
    const existenceFieldPath = bindingPath.joinWith(OptionalElementsExistenceFieldName);
    const visibilityFieldPath = bindingPath.joinWith(OptionalBlockVisibilityFieldName);

    return {
        onCreateBlock: async () => {
            [existenceFieldPath, visibilityFieldPath].forEach(path => {
                dispatch(setToModel(path, "value", TruthyTechnicalFieldValue));
            });

            await dispatch(async (_, __, form) => {
                await form.normalizeSection(id);
            });
        },
        onDeleteBlock: async () => {
            await dispatch(async (_, __, form) => {
                form.removeSection(id, bindingPath);
            });
        },
    };
};

export const OptionalBlockContainer = withResolvePaths(
    withViewModelSelect(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(withTestPageObjectRegistration(OptionalBlock, x => [x.legacyBindingPath]))
    )
);
